import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

const {
	arrayOf, bool, func, number, shape, string
} = propTypes;

const plugins = [Captions, Zoom];
const hidden = () => null;

function PhotoLightbox (props) {
	// The lightbox goes back to `index` whenever it's given a new slides array, so only
	// build one when the photos change, not on every render
	const slides = useMemo(
		() => props.photos.map(photo => ({ src: photo.url, alt: photo.description, title: photo.description })),
		[props.photos]
	);
	// With a single photo there's nothing to move to, so hide the arrows rather than
	// letting them wrap around to the same photo
	const singlePhoto = slides.length < 2;

	return (
		<Lightbox
			className='photo-lightbox'
			open={props.open}
			close={props.onClose}
			index={props.index}
			slides={slides}
			plugins={plugins}
			carousel={{ finite: singlePhoto, padding: '50px' }}
			render={singlePhoto ? { buttonPrev: hidden, buttonNext: hidden } : {}}
		/>
	);
}

PhotoLightbox.propTypes = {
	open: bool.isRequired,
	photos: arrayOf(shape({
		url: string.isRequired,
		description: string
	})).isRequired,
	index: number.isRequired,
	onClose: func.isRequired
};

export default PhotoLightbox;
